import { ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
import useCategories from 'hooks/useCategories';

export default {
  name: 'CategoriesMenu',
  data: () => ({
    formState: null,
    actualCategories: reactive([]),
    someCategoryWasClicked: false,
    openCategoryMenu: ""
  }),
  setup() {
    const route = useRoute();
    const { categories } = useCategories({
      rootOnly: ref(true),
      sort: ref(['orderHint asc']),
    });
    // const shalCat = JSON.parse(JSON.stringify(categories))
    // console.log(JSON.parse(JSON.stringify(categories)))
    const isActive = (slug) =>
      slug === route.params.categorySlug;
    return {
      categories,
      isActive,
    };
  },
  created() {
    window.addEventListener("foo-key-localstorage-changed", () => {
      this.getActualCategories();
    });

    setTimeout(()=>{
      const formattedCategories = []
      this.categories.map(val=>{formattedCategories.push(val)});
      formattedCategories.forEach(val=>{
        this.actualCategories.push(val);
      })
      this.getActualCategories()
    },3000)

  },
  methods: {
    getActualCategories() {
      let store = localStorage.getItem("storeRef");
      if (store) {
        this.categories = this.categories.filter((item) =>
          item.custom
            ? item.custom.customFieldsRaw
                .find((cf) => cf.name == "relevantStores")
                .value.findIndex((storeRef) => storeRef === store) > -1
            : false

        );

        // this.categories.forEach((category, idx) => {
        //   console.log(this.categories[idx])
        //     category.children = category.children.filter((item) =>
        //     item.custom
        //       ? item.custom.customFieldsRaw
        //           .find((cf) => cf.name == "relevantStores")
        //           .value.findIndex((storeRef) => storeRef === store) > -1
        //       : false
        //   );
        // });

        // this.categories.forEach((category) => {
        //   category.children.forEach((subCategory) => {
        //     subCategory.children = subCategory.children.filter((item) =>
        //       item.custom
        //         ? item.custom.customFieldsRaw
        //             .find((cf) => cf.name == "relevantStores")
        //             .value.findIndex((storeRef) => storeRef === store) > -1
        //         : false
        //     );
        //   });
        // });
      }
    },
    isMenuOpen({ id }) {
      return (
        ('ontouchstart' in window || !this.someCategoryWasClicked) &&
        this.openCategoryMenu === id
      );
    },
    hoverOnCategory({ id, children }) {
      if ('ontouchstart' in window) {
        return;
      }
      const hasChildren = Array.isArray(children) && children.length;
      if (hasChildren) {
        this.openCategoryMenu = id;
      }
      this.someCategoryWasClicked = false;
    },
    hoverOffCategory() {
      if ('ontouchstart' in window) {
        return;
      }
      this.openCategoryMenu = false;
    },
    clickOnCategory() {
      this.someCategoryWasClicked = true;
      this.openCategoryMenu = false;
      this.$emit("closeMobile");
    }
  }
};
